var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{style:(_vm.getSize),attrs:{"src":'/icons/' + _vm.path,"uk-svg":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }